var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenToSquareSolid3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square-solid-3",
    d: "M22.336,6.053a2.65,2.65,0,0,0-3.751,0L17.16,7.474,21.8,12.111l1.426-1.426a2.65,2.65,0,0,0,0-3.751ZM8.165,16.473a2.617,2.617,0,0,0-.639,1.037l-1.4,4.206A1.142,1.142,0,0,0,6.4,22.881a1.128,1.128,0,0,0,1.165.275l4.206-1.4a2.685,2.685,0,0,0,1.037-.639l7.924-7.929L16.089,8.544ZM4.547,8.056A4.548,4.548,0,0,0,0,12.6V24.728a4.548,4.548,0,0,0,4.547,4.547H16.672a4.548,4.548,0,0,0,4.547-4.547V20.181a1.516,1.516,0,1,0-3.031,0v4.547a1.514,1.514,0,0,1-1.516,1.516H4.547a1.514,1.514,0,0,1-1.516-1.516V12.6a1.514,1.514,0,0,1,1.516-1.516H9.094a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(0 -5.275)",
    fill: "#0f445a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenToSquareSolid3);
export default __webpack_public_path__ + "static/media/pen-to-square-solid-3.e3ec7f44effb30bc2e36dfabe6a6cf79.svg";
export { ForwardRef as ReactComponent };